import { ShopFilled, ShopOutlined } from "@ant-design/icons";
import { DateDisplay, NameDisplay } from "@easybiz/component";
import {
  useAccessStoreIds,
  useClientState,
  useClientStateSetter,
  useUserBusinessCode,
  useUser,
} from "@easybiz/component-shared";
import { SALES_CHANNEL_TYPE_STORE } from "@easybiz/utils";
import { useCloseOfDayReportDoc } from "@easybiz/web-firebase";
import { Button, Menu } from "antd";
import dayjs from "dayjs";
import React, { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import CloseOfDayDialog from "./CloseOfDayDialog";
import OrderSalesPanel from "./OrderSalesPanel";
import PanelHeader from "./PanelHeader";
import usePOSSalesAccessDate from "./usePOSSalesAccessDate";

export default ({ date, selectOrderId, onClose }) => {
  const storeCode = useUserBusinessCode();
  const [businessCode, setBusinessCode] = useState(storeCode);
  const [endOfDayVisible, setEndOfDayVisible] = useState(false);
  const clients = useUser()?.clients;
  const storeLicenses = useAccessStoreIds();
  const validClients =
    Array.isArray(clients) &&
    Array.isArray(storeLicenses) &&
    clients.filter((client) => storeLicenses.indexOf(client) >= 0);
  const dateKey = date?.format("YYYY-MM-DD");
  const reportDate = usePOSSalesAccessDate(dateKey);
  const today = dayjs().format("YYYY-MM-DD");
  const report = useCloseOfDayReportDoc(reportDate, businessCode);
  const orderListHeight = window.innerHeight - 140;
  const { displayMode } = useClientState();
  const setState = useClientStateSetter();

  const onSelectOrder = useCallback(
    (order) => {
      setState({
        displayMode: {
          ...displayMode,
          orderId: displayMode.orderId === order.id ? null : order.id,
        },
      });
    },
    [setState, displayMode]
  );

  return (
    <>
      <PanelHeader
        title={
          <span>
            <FormattedMessage defaultMessage={"Daily Sales"} />
            {` `}(<DateDisplay date={dateKey} />)
          </span>
        }
        onClose={onClose}
        extra={
          report?.exists() === false && (
            <Button
              loading={!report}
              type={report?.exists() === false && today === dateKey ? "primary" : "default"}
              disabled={dateKey > today}
              onClick={() => setEndOfDayVisible(true)}
            >
              <FormattedMessage tagName={"span"} defaultMessage={"Close of day"} />
            </Button>
          )
        }
      />
      <div className="flex flex-row flex-fill scroll-container">
        {Array.isArray(validClients) && validClients.length > 0 && (
          <div className="scroll-body padding-horizontal-half">
            <Menu
              selectedKeys={[businessCode]}
              onSelect={({ key }) => setBusinessCode(key)}
              items={[
                {
                  key: storeCode,
                  icon: <ShopFilled />,
                  label: <NameDisplay nameKey={storeCode} />,
                },
                {
                  type: "group",
                  label: <FormattedMessage defaultMessage={"Client stores"} />,
                  children: validClients.map((businessCode) => ({
                    key: businessCode,
                    icon: <ShopOutlined />,
                    label: <NameDisplay nameKey={businessCode} />,
                  })),
                },
              ]}
            />
          </div>
        )}
        <div className="flex flex-fill scroll-body">
          <OrderSalesPanel
            height={orderListHeight}
            businessCode={businessCode}
            orderType={SALES_CHANNEL_TYPE_STORE}
            selectOrderId={selectOrderId}
            onSelect={onSelectOrder}
            date={date}
            reportDoc={report}
          />
          <br />
          <br />
          <br />
        </div>
      </div>
      <CloseOfDayDialog
        dateKey={dateKey}
        open={endOfDayVisible}
        onCancel={() => setEndOfDayVisible(false)}
        onComplete={() => setEndOfDayVisible(false)}
      />
    </>
  );
};
